// TrackDelivery.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { baseUrl } from "../Univ";
import L from "leaflet";

const pickupIcon = L.divIcon({
  html: `<div class="pickup-icon">📦</div>`,
  className: "",
  iconSize: [30, 30],
});
// Fix for default marker icon in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

function TrackDelivery() {
  const { orderItemId } = useParams();

  const [delivery, setDelivery] = useState(null);
const driverLat = Number(delivery?.driver_detail?.current_lat);
const driverLng = Number(delivery?.driver_detail?.current_lng);

  const fetchDelivery = () => {
    axios
      .get(baseUrl + `delivery-detail/${orderItemId}/`)
      .then((res) => setDelivery(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchDelivery();
    const interval = setInterval(fetchDelivery, 5000); // refresh every 5 sec
    return () => clearInterval(interval);
  }, [orderItemId]);

  if (!delivery) return <p>Loading delivery...</p>;

  return (
    <div>
      <h4>Delivery Status: {delivery.status}</h4>

{!isNaN(driverLat) && !isNaN(driverLng) ? (
  <MapContainer
    center={[driverLat, driverLng]}
    zoom={13}
    style={{ height: "400px", width: "100%" }}
  >
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

    <Marker position={[driverLat, driverLng]} icon={pickupIcon}>
      <Popup>
        {delivery?.driver_detail?.username || "Driver"} is here
      </Popup>
    </Marker>
  </MapContainer>
) : (
  <p>Shipping Shortly...</p>
)}

    </div>
  );
}

export default TrackDelivery;
